import { CardCheckbox } from '@/components/ui/CardCheckbox'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import type { FieldInputProps } from './fieldInputProps'
import { ScreenFieldKind, togglePick } from './screenForm'

/** MULTI as a checklist, CARDS as cards; each option's help sits under its label. */
export function OptionsField({ field, value, onChange, id, invalid, disabled }: FieldInputProps<string[]>) {
  const toggle = (option: string, checked: boolean) => onChange(togglePick(field, value, option, checked))

  if (field.kind === ScreenFieldKind.CARDS) {
    return (
      <div id={id} className="grid gap-2 sm:grid-cols-2">
        {field.options.map((option) => (
          <CardCheckbox
            key={option.value}
            isChecked={value.includes(option.value)}
            onChange={(checked) => toggle(option.value, checked)}
            disabled={disabled}
            className={invalid ? 'border-destructive' : undefined}
          >
            <span className="block">{option.label}</span>
            {option.help && (
              <span className="text-muted-foreground block text-xs font-normal">{option.help}</span>
            )}
          </CardCheckbox>
        ))}
      </div>
    )
  }

  return (
    <div id={id} className="flex flex-col gap-3">
      {field.options.map((option) => {
        const optionId = `${id}-${option.value}`
        return (
          <div key={option.value} className="flex items-start gap-2">
            <Checkbox
              id={optionId}
              className="mt-0.5"
              checked={value.includes(option.value)}
              onCheckedChange={(checked) => toggle(option.value, checked === true)}
              disabled={disabled}
              aria-invalid={invalid || undefined}
            />
            <div className="flex flex-col">
              <Label htmlFor={optionId} className="font-normal">
                {option.label}
              </Label>
              {option.help && <p className="text-muted-foreground text-xs">{option.help}</p>}
            </div>
          </div>
        )
      })}
    </div>
  )
}
